var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-logo-container",class:{'collapse':_vm.collapse}},[_c('transition',{attrs:{"name":"sidebarLogoFade"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }